import { Box, Flex } from '@chakra-ui/react';

import { Iteration } from 'Component/others';
import SkeletonComponent from 'UiKit/skeleton';

import styles from './styles.module.css';

const SkeletonCard = () => {
  return (
    <Box className={styles['card-presence-content__skeleton']}>
      <Flex width="100%" gap="4px" justifyContent="space-between">
        <SkeletonComponent height="21px" width="40%" />
        <SkeletonComponent height="21px" width="5%" />
      </Flex>
    </Box>
  );
};

const ListPresenceContentSkeleton = () => {
  return (
    <Box className={styles['list-presence-content-skeleton__container']}>
      <Iteration items={Array.from({ length: 6 })} render={() => <SkeletonCard />} />
    </Box>
  );
};

export default ListPresenceContentSkeleton;
